export enum InvitationBanner {
    SPECIAL_GP = 'SPECIAL_GP',
    SPECIAL_GP_SCB = 'SPECIAL_GP_SCB',
    THT_PLUS = 'THT_PLUS',
    THT_PLUS_SCB = 'THT_PLUS_SCB',
    THT_PLUS_VIP = 'THT_PLUS_VIP',
}